import { css, Theme } from "@emotion/react";
import { theme } from "styles/theme";

export const UserLayoutStyle = {
  self: ({ colors }: Theme) => css`
    color: ${colors.black};
  `,

  contentWrapper: css`
    padding: 45px 0;
  `,

  mainContent: ({ colors }: Theme) => css`
    display: flex;
    gap: 30px;
    color: ${colors.black};
  `,

  outlet: css`
    flex: 1;
  `,

  banner: css`
    img {
      width: 100%;
      height: 100%;
      border-bottom: solid 20px ${theme.colors.orange[200]};
    }
  `,
};
